import React from "react";
import { Button, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

import { useDispatch } from "react-redux";
import AmplifyAPIWrapper, { INotifications } from "src/API/AmplifyAPIWrapper";

export interface IManualCheckInCellProps {
  crewId: string;
  pairingId: string;
  style?: any;
}

const OCManualCheckIn = styled("div")(({ theme }) => ({
  display: "flex",
  padding: "10px",
  flexFlow: "row",
  "& .type_icon": {
    paddingRight: "4px",
  },
}));

/**
 * A cell in the table that contains a button to check in a crew member to a pairing
 * @param props - crew id, pairing id
 */
export const ManualCheckIn = (props: IManualCheckInCellProps): JSX.Element => {
  const { crewId, pairingId } = props;
  const dispatch = useDispatch();

  const handleClick = async (event: React.MouseEvent): Promise<void> => {
    event.stopPropagation(); // important when used in the table where rows are clickable.
    if (!crewId || !pairingId) {
      return;
    }

    const notifications: INotifications = {
      dispatch: dispatch,
      infoMessage: "Checking In...",
      successMessage: "Successfully Checked In.",
      errorMessage: "Error: Unable to check In.",
    };

    await AmplifyAPIWrapper.Put<any>(`/crew/checkIn/${pairingId}/${crewId}`, {}, notifications);
  };

  return (
    <OCManualCheckIn>
      <Button id={"check_in_crew_btn"} variant="outlined" onClick={handleClick} disabled={!pairingId || !crewId}>
        {" "}
        <CheckIcon className="type_icon" />
      </Button>
    </OCManualCheckIn>
  );
};
